var attributes = require('html-attributes')

var ATTRIBUTE_NAME_CHAR = ':A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040';

var isCustom = RegExp.prototype.test.bind(new RegExp('^(data|aria)-[' + ATTRIBUTE_NAME_CHAR + ']*$'))

module.exports = function pickAttributes(props) {
  var result = {};

  Object.keys(props).forEach(function(key) {
    if (attributes[key] || isCustom(key))
      result[key] = props[key]
  })

  return result;
}



//////////////////
// WEBPACK FOOTER
// ./~/pick-attributes/index.js
// module id = 1110
// module chunks = 0